import { useQuery } from '@tanstack/react-query';
import authAxios from '@services/authAxios';

const useGetSchemeList = () => {
    return useQuery({
        queryKey: ['promotion-claim', 'scheme-list'],
        queryFn: async () => {
            const { data } = await authAxios.get('/api/v1/master-data/scheme-list');
            return data;
        },
        select: (data) => {
            return {
                ...data,
                listScheme: data.listScheme.map((item) => ({
                    id: item.id,
                    name: `${item.scheme}%`,
                })),
            };
        },
        refetchOnWindowFocus: false,
        retry: false,
        gcTime: 0,
        enabled: false,
    });
};

export default useGetSchemeList;
